import React from 'react';
import { useNavigate } from 'react-router-dom';
import { ROUTES } from '@/urls';
import { T } from '@/theme/tokens';
import { DsIcon } from '@/components/ds/icons';
import CurrencyMenu from './currency-menu';

interface TopbarProps {
  title: string;
  currency: string;
  unreadDisputes: number;
  onHelp: () => void;
}

export default function Topbar({ title, currency, unreadDisputes, onHelp }: TopbarProps) {
  const navigate = useNavigate();

  return (
    <header className="cc-topbar">
      <div style={{ flex: 1, minWidth: 0 }}>
        <div
          style={{
            display: 'flex',
            alignItems: 'center',
            gap: 9,
            fontSize: 12,
            color: T.textFaint3,
            fontWeight: 700,
            marginBottom: 3,
          }}>
          <span>CloudCost</span>
          <span style={{ color: '#C6CFDC' }}>/</span>
          <span style={{ color: T.textSoft }}>{title}</span>
        </div>
        <h1 style={{ margin: 0, fontSize: 23, fontWeight: 900, letterSpacing: '-.5px', color: T.text }}>
          {title}
        </h1>
      </div>

      {/* currency switcher (changes the user's default display currency) */}
      <CurrencyMenu currency={currency} />

      <button
        className="cc-topbar-btn"
        onClick={() => navigate(ROUTES.DASHBOARD)}
        aria-label="Notifications"
        title="Notifications">
        <DsIcon name="bell" size={19} />
        {unreadDisputes > 0 && (
          <span
            style={{
              position: 'absolute',
              top: 9,
              right: 10,
              width: 7,
              height: 7,
              borderRadius: '50%',
              background: T.danger,
              border: '1.5px solid #fff',
            }}
          />
        )}
      </button>

      <button className="cc-topbar-btn" onClick={onHelp} aria-label="Help" title="Take a tour">
        <DsIcon name="help" size={19} />
      </button>
    </header>
  );
}
